import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const REPORT_COUNT = 6;

export const ReportReviewListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: REPORT_COUNT }).map((_, i) => (
      <SkeletonCard key={i} style={styles.cardSpacing}>
        <SkeletonBone width="80%" height={18} />
        <View style={styles.metaRow}>
          <SkeletonBone width="30%" height={12} />
          <SkeletonBone width="50%" height={12} />
        </View>
        <SkeletonBone width="25%" height={11} />
      </SkeletonCard>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  cardSpacing: {
    marginBottom: 12,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
});
